import { useEffect, useRef, useState } from "react";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
export default function SearchInput({
  value = "",
  onChange,
  delay = 350,
  label = "Search records",
  ...props
}) {
  const [draft, setDraft] = useState(value);
  const callback = useRef(onChange);
  callback.current = onChange;
  useEffect(() => {
    setDraft(value);
  }, [value]);
  useEffect(() => {
    if (draft.trim() === value) return undefined;
    const timer = setTimeout(() => callback.current(draft.trim()), delay);
    return () => clearTimeout(timer);
  }, [draft, value, delay]);
  return (
    <TextField
      size="small"
      label={label}
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
}
